import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Divider } from 'antd';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import Tooltip from '@lingxi-common-component/sirius-ui/Tooltip';
import { apiHolder, apis, getIn18Text } from 'api';
import SiteLinkButtonModal from '../SiteLinkButtonModal';
import { genSiteLinkButtonHtml } from '../SiteLinkButtonModal/genButtonHtml';
import style from './style.module.scss';
const siteApi = apiHolder.api.requireLogicalApi(apis.siteApiImpl);
const productApi = apiHolder.api.requireLogicalApi(apis.mailProductImplApi);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const SiteLinkButtonEntry = forwardRef((props, ref) => {
    const { visible, setVisible, pos, mailInsertContent, fromPage, mouseEnter, mouseLeave } = props;
    const businessType = fromPage == 'mail' ? 'NORMAL' : 'MARKETING';
    const [siteLinkButtonModalVisible, setSiteLinkButtonModalVisible] = useState(false);
    const [btnType, setBtnType] = useState(1);
    const [modalTitle, setModalTitle] = useState('');
    const [simpleStyle, setSimpleStyle] = useState(false);
    const [defaultCurrentBtnData, setDefaultCurrentBtnData] = useState();
    const [productTooltipVisible, setProductTooltipVisible] = useState(false);
    const [landingTooltipVisible, setLandingTooltipVisible] = useState(false);
    const insertDefaultBtn = async (defaultBtnType) => {
        var _a;
        setVisible(false);
        const btnNameMap = { 1: 'subscribe', 2: '订阅', 3: 'Ask for products list', 4: 'Learn more' };
        const btnName = btnNameMap[defaultBtnType];
        let siteId, domain;
        if (defaultBtnType == 3 || defaultBtnType == 4) {
            const siteList = await siteApi.getSiteDomainList({ isShowOuterSite: false });
            if (siteList && siteList.length > 0) {
                siteId = siteList[0].siteId;
                if (siteList[0].bindDomains.length > 1) {
                    domain = siteList[0].bindDomains[0];
                }
            }
        }
        let productIds;
        if (defaultBtnType == 3) {
            const data = await productApi.getWaimaoProductList({
                keyword: '',
                page: 1,
                pageSize: 10,
            });
            if (data === null || data === void 0 ? void 0 : data.productDetailList) {
                productIds = data.productDetailList.map(item => item.id);
            }
        }
        let pageId;
        if (defaultBtnType == 4) {
            const data = await siteApi.getLandingPageByStatus({ status: 'ONLINE' });
            if (Array.isArray(data)) {
                pageId = data[0].pageId;
            }
        }
        const aptAttrMap = {
            1: 'GEN_FEEDBACK_PAGE_LINK',
            2: 'GEN_FEEDBACK_PAGE_LINK',
            3: 'GEN_PRODUCT_LIST_LINK',
            4: 'GEN_BTN_LANDING_PAGE_LINK',
        };
        const links = await siteApi.getSiteLinks({
            businessType,
            siteId,
            domain,
            siteOptAttrType: aptAttrMap[defaultBtnType],
            productIds,
            pageIds: pageId ? [pageId] : undefined,
        });
        let btnLink = ((_a = links === null || links === void 0 ? void 0 : links[0]) === null || _a === void 0 ? void 0 : _a.link) || '';
        const subBusinessTypeMap = {
            1: 'FEEDBACK_PAGE',
            2: 'FEEDBACK_PAGE',
            3: 'PRODUCT_LIST_PAGE',
            4: 'LANDING_PAGE',
        };
        const buttonHtml = genSiteLinkButtonHtml({
            link: btnLink,
            businessType: subBusinessTypeMap[defaultBtnType],
            btnName,
            pageId,
        });
        mailInsertContent(buttonHtml);
        trackApi.track('mail_interact_click', { from_page: fromPage, button: defaultBtnType });
    };
    useImperativeHandle(ref, () => ({
        insertDefaultBtn,
        handleOpenCustomModal,
    }));
    const handleOpenProductListModal = (e) => {
        e.stopPropagation();
        setVisible(false);
        setBtnType(1);
        setSiteLinkButtonModalVisible(true);
        setModalTitle('设置商品合集');
        setSimpleStyle(true);
        setDefaultCurrentBtnData({ btnName: 'Ask for products list', id: '' });
        setProductTooltipVisible(false);
    };
    const handleOpenLandingPageModal = (e) => {
        e.stopPropagation();
        setVisible(false);
        setBtnType(2);
        setSiteLinkButtonModalVisible(true);
        setModalTitle('设置营销落地页');
        setSimpleStyle(true);
        setDefaultCurrentBtnData({ btnName: 'Learn more', id: '' });
        setLandingTooltipVisible(false);
    };
    const handleOpenCustomModal = () => {
        setVisible(false);
        setBtnType(1);
        setSiteLinkButtonModalVisible(true);
        setModalTitle('插入自定义按钮');
        setSimpleStyle(false);
        setDefaultCurrentBtnData(undefined);
        trackApi.track('mail_interact_click', { from_page: fromPage, button: 'other' });
    };
    const subscribeTitle = (React.createElement("div", { style: { width: 280 } },
        getIn18Text('SHOUJIANRENRDYJNRGXQ10'),
        React.createElement("br", null),
        getIn18Text('BINGLIUXIALXXXSYYKHY6')));
    const divider = (React.createElement("div", { style: { padding: '0 12px' } },
        React.createElement(Divider, { style: { margin: '3px 0', borderColor: '#F0F1F5' } })));
    return (React.createElement(React.Fragment, null,
        React.createElement(LxPopover, { visible: visible, setVisible: setVisible, top: pos.top, left: pos.left, resetStyle: { boxShadow: 'none', zIndex: 999 } },
            React.createElement("div", { className: style.siteLinkDropdownContainer, onMouseEnter: () => {
                    mouseEnter && mouseEnter();
                }, onMouseLeave: () => {
                    mouseLeave && mouseLeave();
                } },
                React.createElement(Tooltip, { placement: "right", getTooltipContainer: node => node.parentNode, title: subscribeTitle },
                    React.createElement("div", { className: style.siteLinkListItem, onClick: () => insertDefaultBtn(1) }, "subscribe")),
                React.createElement(Tooltip, { placement: "right", getTooltipContainer: node => node.parentNode, title: subscribeTitle },
                    React.createElement("div", { className: style.siteLinkListItem, onClick: () => insertDefaultBtn(2) }, getIn18Text('DINGYUE'))),
                divider,
                React.createElement(Tooltip, { placement: "right", getTooltipContainer: node => node.parentNode, title: React.createElement("div", { style: { width: 280 } },
                        getIn18Text('CHARUGAIANHSJRDJKCKX18'),
                        React.createElement("a", { style: { color: '#94A6FF' }, onClick: handleOpenProductListModal }, getIn18Text('SHEZHISHANGP'))), visible: productTooltipVisible, onVisibleChange: setProductTooltipVisible },
                    React.createElement("div", { className: style.siteLinkListItem, onClick: () => insertDefaultBtn(3) }, "Ask for products list")),
                React.createElement(Tooltip, { placement: "right", getTooltipContainer: node => node.parentNode, title: React.createElement("div", { style: { width: 280 } },
                        getIn18Text('SHOUJIANRENDJHKCKXZD16'),
                        React.createElement("a", { style: { color: '#94A6FF' }, onClick: handleOpenLandingPageModal }, getIn18Text('SHEZHIYINGXLDY'))), visible: landingTooltipVisible, onVisibleChange: setLandingTooltipVisible },
                    React.createElement("div", { className: style.siteLinkListItem, onClick: () => insertDefaultBtn(4) }, "Learn more")),
                divider,
                React.createElement("div", { className: style.siteLinkListItem, onClick: handleOpenCustomModal },
                    React.createElement("a", null, getIn18Text('ZIDINGYIAN'))))),
        siteLinkButtonModalVisible && (React.createElement(SiteLinkButtonModal, { getContainer: props.getContainer, fromPage: fromPage, visible: siteLinkButtonModalVisible, onClose: () => setSiteLinkButtonModalVisible(false), onOk: htmlContent => mailInsertContent(htmlContent), btnType: btnType, setBtnType: setBtnType, modalTitle: modalTitle, simpleStyle: simpleStyle, defaultCurrentBtnData: defaultCurrentBtnData }))));
});
export default SiteLinkButtonEntry;
